export const EVENTS = {
    MENU_LEFT: "MENU_LEFT",
    HEADER_BREADCRUMB: "HEADER_BREADCRUMB",
    UPDATE_ACCOUNT_INFO: "UPDATE_ACCOUNT_INFO",
    LOADED_PROJECTS_SUCCESSFULLY: "LOADED_PROJECTS_SUCCESSFULLY"
};
